import React, { createContext, useContext, useReducer } from "react";
import { initialFilterSafariPackages, initialSummary } from "../Data/safariPackages";
import { safariPackagesReducer } from "../reducers/safariPackagesReducer";

//Create context
export const SafariPackagesContext = createContext();

//Initial state
const initialState = {
  //for listing
  safariPackagesData: [],
  summary: initialSummary,
  filters: initialFilterSafariPackages,
  pageIndex: 1,
  loading: true,

  //for view
  packageViewData: null,
  packageViewLoading: true,
  packageViewError: '',
  packageEnquriToggle: false,
  tabKey: 'overview',
  commentsUrl: '',
  userComments: [],
  summaryUserComment: initialSummary,
  pageIndexUserComment: 1,
  reportContentToggle: false,
  commentForFlag: null
};

//Provider
const SafariPackagesProvider = ({ children }) => {
  const [safariPackagesState, safariPackagesDispatch] = useReducer(safariPackagesReducer, initialState);

  return (
    <SafariPackagesContext.Provider
      value={{
        ...safariPackagesState,
        safariPackagesDispatch,
      }}
    >
      {children}
    </SafariPackagesContext.Provider>
  );
};

//hook
export const useSafariPackagesContext = () => useContext(SafariPackagesContext);

export default SafariPackagesProvider;
